/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import Icons from './icons/Icons';
import { getFontColorClassNameOLD, colorClassNames } from '../styles/Colors';

// accessibility: should this be a checkbox?

interface FlagToggleProps {
  isFlagged: boolean;
  onClick(): void;
  colorTheme: 'default' | 'white';
  align: 'left' | 'right';
}
const FlagToggle: FC<FlagToggleProps> = (props) => {
  const contentAlignment = classnames('cmp-flagtoggle--content', {
    'align-left': props.align === 'left',
    'align-right': props.align === 'right',
  });
  const flagPhrase = props.isFlagged ? 'flag.flagStatusOn.button.label' : 'flag.flagStatusOff.button.label';
  return (
    <div id="flagged" className="cmp-flagtoggle" onClick={props.onClick}>
      <div className={contentAlignment}>
        {
          props.isFlagged ? <Icons.FlaggedCircle color="profile-highlight" /> : <Icons.FlagCircle color={props.colorTheme} />
        }

        <label htmlFor="flagged" className={classnames('font-caption-1', getFontColorClassNameOLD(props.colorTheme))}>
          <FormattedMessage id={flagPhrase} />
        </label>

      </div>
    </div>
  );
};

export const FlaggedIcon = () => (
  <div className="cmp-flagged-icon profile-background-color-highlight" />
);

interface FlagToggleHorizontalProps {
  isFlagged: boolean;
  onClick(): void;
  colorTheme: string;
}
export const FlagToggleHorizontal: FC<FlagToggleHorizontalProps> = (props) => {
  const colorClassName = props.isFlagged ? classnames(colorClassNames.border('profile-highlight'), colorClassNames.background('profile-highlight')) : colorClassNames.border(props.colorTheme);

  return (
    <div id="flagged" className="cmp-flagtoggle__horizontal" onClick={props.onClick}>
      <div className={classnames('__flag-dot', colorClassName)} />

      <label htmlFor="flagged" className={classnames('font-caption-1', getFontColorClassNameOLD(props.colorTheme))}>
        {
          props.isFlagged ? <FormattedMessage id="flag.flagStatusOn.button.label" /> : <FormattedMessage id="flag.flagStatusOff.button.label" />
        }
      </label>
    </div>
  );
}

export default FlagToggle;
